
import {Component, Vue} from 'vue-property-decorator';
//@ts-ignore
import Password from 'vue-password-strength-meter'
import {UserLoginAcceptedCode, UserLoginAcceptStatus, userService} from "@/modules/federation/services/UserService";
import LoadingButton from "@/components/general/buttons/LoadingButton.vue";
import EqifyLoader from "@/components/EqifyLoader.vue";
import EqifyDataLoader from "@/components/EqifyDataLoader.vue";

@Component({
  components: {
    EqifyDataLoader,
    EqifyLoader,
    LoadingButton,
    Password
  }
})
export default class AuthAcceptInvitationView extends Vue {
  form: Form = new Form();
  passwordLength = 6;
  status: UserLoginAcceptStatus = UserLoginAcceptStatus.UNKNOWN;
  acceptStatus: UserLoginAcceptedCode = UserLoginAcceptedCode.SUCCESS;

  get personRef() {
    return this.$route.params.person
  }

  mounted() {
    this.$loader.load(async () => {
      this.status = (await userService.getAcceptStatus(this.personRef)).code
    }, "auth::accept")
  }

  accept(evt?: Event) {
    if (evt) {
      evt.preventDefault();
    }
    this.$loader.load(async () => {
      let {code, username} = await userService.accept(this.personRef, this.form.password)
      this.acceptStatus = code
      if (this.acceptStatus == UserLoginAcceptedCode.SUCCESS) {
        await this.$keycloak.login!({loginHint: username, redirectUri: window.location.origin})
      }
    })
  }

  get showAcceptedStatus() {
    return this.acceptStatus && this.acceptStatus != UserLoginAcceptedCode.SUCCESS;
  }
}

class Form {
  password!: string;
}
